import { UrlsConstant } from './urls-constant.enum';
import { LabelConfigPipe } from '../../../core/pipe/labelConfig/label-config.pipe';
import { LocalDataStorageService } from '../../../core/service/local-data-storage.service';
const urls = UrlsConstant;
const local = new LocalDataStorageService();

export const ModuleUrlsConstant = {
  transport: {
    id: 1,
    title: 'Transport',
    moduleUrl: 'chemical/transport',
    addUpdateUrl: urls.transport,
  },
  ph: {
    id: 2,
    title: new LabelConfigPipe(local).transform('label_name_stock_param1', 'Stock Param 1'),
    moduleUrl: 'chemical/ph',
    addUpdateUrl: urls.pH,
  },
  moisture: {
    id: 3,
    title: new LabelConfigPipe(local).transform('label_name_stock_param2', 'Stock Param 2'),
    moduleUrl: 'chemical/moisture',
    addUpdateUrl: urls.moisture,
  },
  solubility: {
    id: 4,
    title: new LabelConfigPipe(local).transform('label_name_stock_param3', 'Stock Param 3'),
    moduleUrl: 'chemical/solubility',
    addUpdateUrl: urls.solubility,
  },
  purity: {
    id: 5,
    title: new LabelConfigPipe(local).transform('label_name_cost_param', 'Cost Param'),
    moduleUrl: 'chemical/purity',
    addUpdateUrl: urls.purity,
  },
  funnelStage: {
    id: 6,
    title: 'Funnel Stage',
    moduleUrl: 'crm/funnelStage',
    addUpdateUrl: urls.funnelStage,
  },
  process: {
    id: 7,
    title: 'Process',
    moduleUrl: 'chemical/process',
    addUpdateUrl: urls.process,
  },
  costHead: {
    id: 8,
    title: 'Cost Head',
    moduleUrl: 'chemical/costHead',
    addUpdateUrl: urls.costHead,
  },
  department: {
    id: 9,
    title: 'Department',
    moduleUrl: 'chemical/department',
    addUpdateUrl: urls.department,
  },
  materialType: {
    id: 10,
    title: 'Material Type',
    moduleUrl: 'chemical/productType',
    addUpdateUrl: urls.materialType,
  },
  crmActivity: {
    id: 11,
    title: 'CRM Activity',
    moduleUrl: 'crm/activity',
    addUpdateUrl: urls.costHead,
  },
  machine: {
    id: 12,
    title: 'Machine',
    moduleUrl: 'chemical/machine',
    addUpdateUrl: urls.machine,
  },
  filterDataUrl: {
    saleOrderFilterCustomerWise: {
      filterUrl: 'chemical/salesOrder/getAllByCustomer/',
    },
  },
  location: {
    id: 13,
    title: 'Location',
    moduleUrl: 'erp/location',
    addUpdateUrl: urls.location,
  },
  branch: {
    id: 14,
    title: 'Branch',
    moduleUrl: 'erp/branch',
    addUpdateUrl: urls.branch,
  },
};
